import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const CTA: React.FC = () => {
  const { isAuthenticated, subscription, user } = useAuth();
  const navigate = useNavigate();

  const getPrimaryButtonProps = () => {
    if (!isAuthenticated) {
      return {
        href: '/register',
        text: 'Create Account',
        onClick: undefined
      };
    }

    return {
      href: '/movies',
      text: 'Browse Movies',
      onClick: undefined
    };
  };

  const getSecondaryButtonProps = () => {
    if (!isAuthenticated) {
      return {
        href: '/login',
        text: 'Login',
        onClick: undefined
      };
    }

    if (user?.role === 'admin' || subscription?.has_subscription) {
      return {
        href: '/watch-party/create',
        text: 'Create Your Club',
        onClick: undefined
      };
    }

    return {
      href: '#',
      text: 'Start Free Trial',
      onClick: (e: React.MouseEvent) => {
        e.preventDefault();
        navigate('/subscribe');
      }
    };
  };

  const primaryProps = getPrimaryButtonProps();
  const secondaryProps = getSecondaryButtonProps();

  return (
    <div className="relative py-8 lg:py-16 scroll-reveal">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="bg-gradient-to-r from-netflix-red/15 to-transparent rounded-2xl p-6 lg:p-12 text-center backdrop-blur-sm">
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-black mb-3 lg:mb-4">
            Ready to Start Watching?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-netflix-light-gray mb-6 lg:mb-8 max-w-2xl mx-auto">
            Join CineClubs today and experience movies like never before.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-md mx-auto">
            <Link
              to={primaryProps.href}
              onClick={primaryProps.onClick}
              className="w-full sm:w-auto px-6 lg:px-8 py-3 lg:py-4 hover:opacity-90 rounded-lg text-base lg:text-lg font-bold transition-all text-white text-center"
              style={{ background: 'linear-gradient(135deg, rgba(229, 9, 20, 0.8), rgba(255, 10, 22, 0.8))' }}
            >
              {primaryProps.text}
            </Link>
            <Link
              to={secondaryProps.href}
              onClick={secondaryProps.onClick}
              className="w-full sm:w-auto px-6 lg:px-8 py-3 lg:py-4 bg-white/10 hover:bg-white/20 rounded-lg text-base lg:text-lg font-bold transition-all text-center"
            >
              {secondaryProps.text}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
